import { createContext } from 'react';
export const DataContext = createContext(null);
export const DataStateContext = createContext(null);
